// import Blub from './../vuecomponents/blub.vue';
//import {createApp} from 'vue';

import {createApp} from "vue";
import MarktberichteFilter from "../vuecomponents/MarktberichteFilter.vue";
import {DatePickerMonths as months} from "../vuecomponents/marktberichte/Globals.ts";
import {BerichteWithMeta, CategoryEventPayload, FromToEventPayload} from "../vuecomponents/marktberichte/Types.ts";
import {yearmonthToTimestamp} from "../vuecomponents/marktberichte/Helper.ts";
import {initImageLightbox} from "./lightbox.mjs";

declare let isLoggedIn: boolean;

function getBerichte(): BerichteWithMeta {
    return Array.from(document.querySelectorAll<HTMLElement>('.marktberichte__bericht'))
        .map(node => {
            const nodeDate = node.getAttribute('data-date');
            const nodeCat = node.getAttribute('data-cat');
            return {
                valid: nodeDate != null && nodeCat != null,
                node: node,
                date: yearmonthToTimestamp(nodeDate || '', months),
                cat: nodeCat || ''
            };
        });
}

function filterBerichte(p?: FromToEventPayload | CategoryEventPayload) {
    const berichte = getBerichte();
    if (p && p.type === 'date') {
        const from = yearmonthToTimestamp(p.min, months);
        const to = yearmonthToTimestamp(p.max, months);
        if (from === null && to === null) {
            console.warn('datefilter incomplete, from or to missing');
            return;
        }

        berichte.forEach(bericht => {
            if (from == null && to == null) {
                return;
            }
            if (bericht.date && (!from || bericht.date >= from) && (!to || bericht.date <= to)) {
                bericht.node.classList.remove('marktberichte__bericht--hidden');
            } else {
                bericht.node.classList.add('marktberichte__bericht--hidden');
            }
        });
    } else{
        berichte.forEach(bericht => {
            const catsShown = new Set(
                Array.from(document.querySelectorAll('.marktberichte__categories input:checked'))
                    .map(node => node.getAttribute('data-cat') || '')
            );
            if (catsShown.size === 0 || catsShown.has(bericht.cat)) {
                bericht.node.classList.remove('marktberichte__bericht--hiddenCat');

            } else {
                bericht.node.classList.add('marktberichte__bericht--hiddenCat');
            }
        });
    }
    updateEmptyTopics();
}

function updateCategories() {
    const allCategories = new Set(
        Array.from(document.querySelectorAll('.marktberichte .marktberichte__bericht'))
            .map(node => node.getAttribute('data-cat') || '')
    );
    const visibleCategories = new Set(
        Array.from(document.querySelectorAll('.marktberichte .marktberichte__bericht:not(.marktberichte__bericht--hidden)'))
            .map(node => node.getAttribute('data-cat') || '')
    );
    for (const cat of allCategories){
        const filterElem = document.querySelector('.marktberichte__categories input[data-cat="'+cat+'"]');
        if(!(filterElem instanceof HTMLInputElement)) continue;
        if(visibleCategories.has(cat)){
            filterElem.nextElementSibling?.classList.remove("d2buttonround--check--disabled");
        }else{
            filterElem.checked = false;
            filterElem.nextElementSibling?.classList.add("d2buttonround--check--disabled");
            checkCatAllButton();
        }
    }

}
function getNewestAndOldest(){
    let newest;
    let oldest;
    const berichte = getBerichte();
    for (let bericht of berichte){
        if (!bericht.date) continue
        if (!newest || bericht.date>newest){
            newest = bericht.date;
        }
        if (!oldest || bericht.date<oldest){
            oldest = bericht.date;
        }
    }
    return [newest,oldest]
}

function showLogin(){
    if (typeof isLoggedIn === 'undefined' || !isLoggedIn) {
        document.querySelector(".marktberichte__login")?.classList.add("marktberichte__login--show");
        return true
    }
    return false
}

function updateEmptyTopics(){
    const topics = document.querySelectorAll(".marktberichte__imageheader");
    if (topics.length ===0){
        const subpage_berichte = document.querySelectorAll(".marktberichte__bericht");
        if (!subpage_berichte) return;
        const subpage_berichte_visible = Array.from(subpage_berichte).filter(a => {
            return getComputedStyle(a).display !== "none";
        });
        if (subpage_berichte_visible.length === 0){
            document.querySelector(".marktberichte__emptynotice")?.classList.add("marktberichte__emptynotice--visible");
        }else{
            document.querySelector(".marktberichte__emptynotice")?.classList.remove("marktberichte__emptynotice--visible");
        }
    }else{
        for (let topic of topics){
            const topic_berichte = topic.nextElementSibling?.querySelectorAll(".marktberichte__bericht");
            if (!topic_berichte) continue
            const topic_berichte_visible = Array.from(topic_berichte).filter(a => {
                return getComputedStyle(a).display !== "none";
            });
            if (topic_berichte_visible.length === 0){
                topic.nextElementSibling?.querySelector(".marktberichte__emptynotice")?.classList.add("marktberichte__emptynotice--visible");
            }else{
                topic.nextElementSibling?.querySelector(".marktberichte__emptynotice")?.classList.remove("marktberichte__emptynotice--visible");
            }
        }
    }
}

function checkCatAllButton(){
    if(document.querySelector('.marktberichte__categories input:checked')){
        document.getElementById("catFilter-all")?.classList.remove("d2buttonround--check--active");
    }else{
        document.getElementById("catFilter-all")?.classList.add("d2buttonround--check--active");
    }
}

export function initmarktberichte() {
    const mb = document.querySelector<HTMLElement>('.marktberichte');
    if (!mb) {
        console.warn('element with class "marktberichte" not found.');
        return;
    }
    const vueInitNode = document.querySelector<HTMLElement>('.marktberichte__filters__init');
    const toggleNode = mb.querySelector<HTMLElement>('.marktberichte__compacttoggle');
    const mbImages = document.querySelectorAll<HTMLImageElement>('.marktberichte__bericht__text > img, .marktberichte__bericht__text > p img');
    const openLightbox = initImageLightbox();

    const berichte = mb.querySelectorAll(".marktberichte__bericht")
    if(berichte){
        for (const bericht of berichte){
            if(typeof isLoggedIn !== 'undefined' && isLoggedIn){
                bericht.addEventListener("click", (e)=>{
                    if (!(e.target instanceof HTMLElement)) {
                        return;
                    }
                    if (e.target.classList.contains('marktberichte__bericht__header') || e.target.closest('.marktberichte__bericht__header')) {
                        e.target?.closest('.marktberichte__bericht__header')?.nextElementSibling?.querySelector('.marktberichte__bericht__text')?.classList.toggle('marktberichte__bericht__text--expanded');
                    }

                })
            }
            const content = bericht.querySelector(".marktberichte__bericht__text") as HTMLElement
            if (content.scrollHeight <= parseFloat(getComputedStyle(content).fontSize) * 2.8){
                bericht.classList.add("marktberichte__short-text");
            }
            const summary = bericht.querySelector(".marktberichte__bericht__text p") as HTMLElement
            if (summary.scrollHeight <= parseFloat(getComputedStyle(summary).fontSize) * 1.8){
                summary.parentElement?.classList.add("marktberichte__short-intro");
            }
        }
    }
    if (typeof isLoggedIn === 'undefined' || !isLoggedIn) {
        mb.classList.add("marktberichte--compact")
    }

    mb.addEventListener("click", e => {
        if (!(e.target instanceof HTMLElement)) {
            return;
        }
        if (e.target.classList.contains('marktberichte__bericht__login') || e.target.closest('.marktberichte__openLogin')) {
            showLogin();
            e.stopImmediatePropagation();
            e.preventDefault();
            //document.querySelector('body')?.classList.add('cc-login-active');
        }
        if (e.target.classList.contains('marktberichte__login')) {
            document.querySelector(".marktberichte__login")?.classList.remove("marktberichte__login--show");
        }
        if (e.target.classList.contains('marktberichte__login__loginbutton')) {
            document.querySelector(".marktberichte__login")?.classList.remove("marktberichte__login--show");
            document.querySelector('body')?.classList.add('cc-login-active');
        }
    });

    if (vueInitNode) {
        const generateFilters = mb.getAttribute('nofilters') !== 'true';
        const app = createApp(MarktberichteFilter, {
            generateFilters
        });
        app.mount(vueInitNode);
    }

    if (toggleNode) {
        toggleNode.addEventListener("click", function () {
            mb.classList.toggle('marktberichte--compact');
            document.querySelectorAll('.marktberichte__bericht__text').forEach((x)=>x.classList.remove('marktberichte__bericht__text--expanded'))
        });
    }

    const toggleNodeCats = mb.querySelector<HTMLElement>('.marktberichte__categoriestoggle');
    if (toggleNodeCats) {toggleNodeCats.addEventListener("click", function () {mb.querySelector("form")?.classList.toggle('marktberichte__filterswrapper--compactCats');});}

    const filterButtons = mb.querySelectorAll(".marktberichte__categories input");
    if(filterButtons){
        for (const catFilter of filterButtons){
            catFilter.addEventListener("change", ()=>{
                if(!(catFilter instanceof HTMLInputElement)) return;
                checkCatAllButton();
                filterBerichte();
            });
        }
    }
    const filterButtonAll = document.getElementById("catFilter-all");
    if(filterButtonAll){
        filterButtonAll.addEventListener("click",()=> {
            filterButtonAll.classList.add("d2buttonround--check--active");
            const checkedFilters = document.querySelectorAll<HTMLInputElement>(".marktberichte__categories input:checked");
            for (const catFilter of checkedFilters ){
                catFilter.checked = false;
            }

            filterBerichte();
        });
    }

    //updateEmptyTopics();

    mbImages.forEach((node) => {
        node.addEventListener('click', function() {
            openLightbox(this);
        });
    });

}


export {filterBerichte};
export {getBerichte};
export {updateCategories};
export {getNewestAndOldest};
export {showLogin};
